import {Routes} from '@angular/router';
import {authRoutes} from './routes/auth.routes';
import {isSignedInGuard} from './guards/is-signed-in.guard';
import {customersRoutes} from './routes/customers.routes';

export const routes: Routes = [
  ...authRoutes,
  {
    path: 'callback/horus',
    loadComponent: () => import('./layout/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [isSignedInGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
      }
    ]
  },
  {
    path: 'callback/exact-online',
    loadComponent: () => import('./layout/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [isSignedInGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
      }
    ]
  },
  {
    path: 'app',
    loadComponent: () => import('./layout/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [isSignedInGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
      },
      ...customersRoutes,
      {
        path: 'files',
        loadComponent: () => import('./pages/files-overview/files-overview.component').then(m => m.FilesOverviewComponent),
      },
      {
        path: 'banks',
        loadComponent: () => import('./pages/banks/banks-overview/banks-overview.component').then(m => m.BanksOverviewComponent),
      },
      {
        path: 'profile',
        loadComponent: () => import('./pages/profile/profile.component').then(m => m.ProfileComponent),
      },
      {
        path: 'mandates',
        loadComponent: () => import('./pages/mandates/mandates-overview/mandates-overview.component').then(m => m.MandatesOverviewComponent),
      }, {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      }
    ]
  }, {
    path: '**',
    redirectTo: 'auth',
    pathMatch: 'full',
  }
];
